<template>
  <div>
    <v-toolbar dark prominent>
      <v-app-bar-nav-icon>
        <v-icon color="blue darken-2" @click="backButton">
          mdi-arrow-left
        </v-icon>
      </v-app-bar-nav-icon>

      <v-col cols="10" md="11" sm="12">
        <v-img
            src="/img/fantasy_lineups_logo.png"
            class="logo mx-auto"
            width="300"
            contain
        />
      </v-col>
    </v-toolbar>

    <v-tabs
        v-model="tab"
        background-color="#32cd32"
        dark
        centered
        class="mb-2 tab-row"
    >
      <v-tabs-slider color="#17408B"></v-tabs-slider>

      <template>
        <v-tab href="#games"> Games Bet</v-tab>
      </template>

      <template>
        <v-tab href="#props"> Props Bet</v-tab>
      </template>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-col cols="12" md="12" sm="12" class="mx-auto mt-4 text-center">
        <v-btn-toggle
            color="#73c603"
            v-model="sportId"
            dense
            mandatory
        >
          <v-btn :value="4">NFL</v-btn>
          <v-btn :value="2">MLB</v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col cols="12" md="12" sm="12" class="mx-auto mb-5 text-center">
        <v-btn-toggle
            color="#73c603"
            v-model="toggle_exclusive"
            dense
            mandatory
        >
          <v-btn @change="handleClick('6107f818963dc87f216fa505')"> Chazmule</v-btn>

          <v-btn @change="handleClick('60fedc56109bcffeb7010994')"> doughboys123</v-btn>
        </v-btn-toggle>
      </v-col>

      <!--chazmule-->
      <v-col
          v-if="toggle_exclusive === 0"
          cols="12"
          md="12"
          sm="12"
          class="mx-auto mb-5 text-center"
      >
        <!-- games tab -->
        <v-tab-item value="games">
          <v-col cols="12" md="7" sm="6" class="mx-auto">
            <v-sheet class="ma-5 pa-3" elevation="3" rounded>
              <v-col>
                <strong class="text-h5">Gold</strong>
                <wysiwyg v-model="chazumle.gameBet.gold"/>
                <!--                <froala id="cz-game-bet-gold" :tag="'div'" v-model="chazumle.gameBet.gold"></froala>-->
              </v-col>

              <v-col>
                <strong class="text-h5">Silver</strong>
                <wysiwyg v-model="chazumle.gameBet.silver"/>
                <!--                <froala id="cz-game-bet-silver" :tag="'div'" v-model="chazumle.gameBet.silver"></froala>-->
              </v-col>

              <v-col>
                <strong class="text-h5">Bronze</strong>
                <wysiwyg v-model="chazumle.gameBet.bronze"/>
                <!--                <froala id="cz-game-bet-bronze" :tag="'div'" v-model="chazumle.gameBet.bronze"></froala>-->
              </v-col>

              <v-col>
                <strong class="text-h5">Remark</strong>
                <wysiwyg v-model="chazumle.gameBet.remark"/>
                <!--                <froala id="cz-game-bet-remark" :tag="'div'" v-model="chazumle.gameBet.remark"></froala>-->
              </v-col>

              <v-col>
                <v-btn block color="success" depressed @click="sendUserGameBet">
                  Submit
                </v-btn>
              </v-col>
            </v-sheet>
          </v-col>
        </v-tab-item>

        <!-- props tab -->
        <v-tab-item value="props">
          <v-col cols="12" md="7" sm="6" class="mx-auto">
            <v-sheet class="ma-5 pa-3" elevation="3" rounded>
              <v-col>
                <strong class="text-h5">Gold</strong>
                <wysiwyg v-model="chazumle.propsBet.gold"/>
                <!--                <froala id="cz-prop-bet-gold" :tag="'div'" v-model="chazumle.propsBet.gold"></froala>-->
              </v-col>

              <v-col>
                <strong class="text-h5">Silver</strong>
                <wysiwyg v-model="chazumle.propsBet.silver"/>
                <!--                <froala id="cz-prop-bet-silver" :tag="'div'" v-model="chazumle.propsBet.silver"></froala>-->
              </v-col>

              <v-col>
                <strong class="text-h5">Bronze</strong>
                <wysiwyg v-model="chazumle.propsBet.bronze"/>
                <!--                <froala id="cz-prop-bet-bronze" :tag="'div'" v-model="chazumle.propsBet.bronze"></froala>-->
              </v-col>

              <v-col>
                <strong class="text-h5">Remark</strong>
                <wysiwyg v-model="chazumle.propsBet.remark"/>
                <!--                <froala id="cz-prop-bet-remark" :tag="'div'" v-model="chazumle.propsBet.remark"></froala>-->
              </v-col>

              <v-col>
                <v-btn block color="success" depressed @click="sendUserPropsBet">
                  Submit
                </v-btn>
              </v-col>
            </v-sheet>
          </v-col>
        </v-tab-item>
      </v-col>

      <!--doughboys123-->
      <v-col
          v-if="toggle_exclusive === 1"
          cols="12"
          md="12"
          sm="12"
          class="mx-auto mb-5 text-center"
      >
        <!-- games tab -->
        <v-tab-item value="games">
          <v-col cols="12" md="7" sm="6" class="mx-auto">
            <v-sheet class="ma-5 pa-3" elevation="3" rounded>
              <v-col>
                <strong class="text-h5">Gold</strong>
                <wysiwyg v-model="doughboys.gameBet.gold"/>
                <!--                <froala id="db-game-bet-gold" :tag="'div'" v-model="doughboys.gameBet.gold"></froala>-->
              </v-col>

              <v-col>
                <strong class="text-h5">Silver</strong>
                <wysiwyg v-model="doughboys.gameBet.silver"/>
                <!--                <froala id="db-game-bet-silver" :tag="'div'" v-model="doughboys.gameBet.silver"></froala>-->
              </v-col>

              <v-col>
                <strong class="text-h5">Bronze</strong>
                <wysiwyg v-model="doughboys.gameBet.bronze"/>
                <!--                <froala id="db-game-bet-bronze" :tag="'div'" v-model="doughboys.gameBet.bronze"></froala>-->
              </v-col>

              <v-col>
                <strong class="text-h5">Remark</strong>
                <wysiwyg v-model="doughboys.gameBet.remark"/>
                <!--                <froala id="db-game-bet-remark" :tag="'div'" v-model="doughboys.gameBet.remark"></froala>-->
              </v-col>

              <v-col>
                <v-btn block color="success" depressed @click="sendUserGameBet">
                  Submit
                </v-btn>
              </v-col>
            </v-sheet>
          </v-col>
        </v-tab-item>

        <!-- props tab -->
        <v-tab-item value="props">
          <v-col cols="12" md="7" sm="6" class="mx-auto">
            <v-sheet class="ma-5 pa-3" elevation="3" rounded>
              <v-col>
                <strong class="text-h5">Gold</strong>
                <wysiwyg v-model="doughboys.propsBet.gold"/>
                <!--                <froala id="db-prop-bet-gold" :tag="'div'" v-model="doughboys.propsBet.gold"></froala>-->

              </v-col>

              <v-col>
                <strong class="text-h5">Silver</strong>
                <wysiwyg v-model="doughboys.propsBet.silver"/>
                <!--                <froala id="db-prop-bet-silver" :tag="'div'" v-model="doughboys.propsBet.silver"></froala>-->

              </v-col>

              <v-col>
                <strong class="text-h5">Bronze</strong>
                <wysiwyg v-model="doughboys.propsBet.bronze"/>
                <!--                <froala id="db-prop-bet-bronze" tag="a" v-model="doughboys.propsBet.bronze"></froala>-->

              </v-col>

              <v-col>
                <strong class="text-h5">Remark</strong>
                <wysiwyg v-model="doughboys.propsBet.remark"/>
                <!--                <froala id="db-prop-bet-remark" tag="a" v-model="doughboys.propsBet.remark"></froala>-->

              </v-col>

              <v-col>
                <v-btn block color="success" depressed @click="sendUserPropsBet">
                  Submit
                </v-btn>
              </v-col>
            </v-sheet>
          </v-col>
        </v-tab-item>
      </v-col>
    </v-tabs-items>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: "bestBetForm",

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("role") !== "client") {
      next({name: "Pricing"});
    } else {
      next();
    }
  },

  mounted() {
    this.handleClick('6107f818963dc87f216fa505')
  },

  data() {
    return {
      tab: null,
      toggle_exclusive: 0,
      sportId: 4,
      chazumle: {
        gameBet: {
          gold: "",
          silver: "",
          bronze: "",
          remark: "",
        },
        propsBet: {
          gold: "",
          silver: "",
          bronze: "",
          remark: "",
        }
      },
      doughboys: {
        gameBet: {
          gold: "",
          silver: "",
          bronze: "",
          remark: "",
        },
        propsBet: {
          gold: "",
          silver: "",
          bronze: "",
          remark: "",
        }
      },
    };
  },

  computed: {
    ...mapState("userModule", ["bestBet", "bestBetProp"]),
  },

  watch: {
    sportId() {
      const expertId = this.toggle_exclusive === 0
        ? "6107f818963dc87f216fa505"
        : "60fedc56109bcffeb7010994";
      this.handleClick(expertId);
    },
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },

    handleClick(userId) {
      this.setGameBet(userId);
      this.setPropsBet(userId);
    },

    setGameBet(id) {
      this.$store.dispatch("userModule/getBestBet", { sportId: this.sportId, id }).then(() => {
        if (this.bestBet.doc) {
          if (this.toggle_exclusive === 0) {
            this.chazumle.gameBet.gold = this.bestBet?.doc?.gold;
            this.chazumle.gameBet.silver = this.bestBet?.doc?.silver;
            this.chazumle.gameBet.bronze = this.bestBet?.doc?.bronze;
            this.chazumle.gameBet.remark = this.bestBet?.doc?.remark;
          } else {
            this.doughboys.gameBet.gold = this.bestBet?.doc?.gold;
            this.doughboys.gameBet.silver = this.bestBet?.doc?.silver;
            this.doughboys.gameBet.bronze = this.bestBet?.doc?.bronze;
            this.doughboys.gameBet.remark = this.bestBet?.doc?.remark;
          }
        }
      });
    },

    setPropsBet(id) {
      this.$store.dispatch("userModule/getBestBetProps", { sportId: this.sportId, id }).then(() => {
        if (this.bestBetProp.doc) {
          if (this.toggle_exclusive === 0) {
            this.chazumle.propsBet.gold = this.bestBetProp?.doc?.gold;
            this.chazumle.propsBet.silver = this.bestBetProp?.doc?.silver;
            this.chazumle.propsBet.bronze = this.bestBetProp?.doc?.bronze;
            this.chazumle.propsBet.remark = this.bestBetProp?.doc?.remark;
          } else {
            this.doughboys.propsBet.gold = this.bestBetProp?.doc?.gold;
            this.doughboys.propsBet.silver = this.bestBetProp?.doc?.silver;
            this.doughboys.propsBet.bronze = this.bestBetProp?.doc?.bronze;
            this.doughboys.propsBet.remark = this.bestBetProp?.doc?.remark;
          }
        }
      });
    },
    sendUserGameBet() {
      let obj = {
        sportId: this.sportId,
        id: this.toggle_exclusive === 0 ? "6107f818963dc87f216fa505" : "60fedc56109bcffeb7010994",
        gold: this.toggle_exclusive === 0 ? this.chazumle.gameBet.gold : this.doughboys.gameBet.gold,
        silver: this.toggle_exclusive === 0 ? this.chazumle.gameBet.silver : this.doughboys.gameBet.silver,
        bronze: this.toggle_exclusive === 0 ? this.chazumle.gameBet.bronze : this.doughboys.gameBet.bronze,
        remark: this.toggle_exclusive === 0 ? this.chazumle.gameBet.remark : this.doughboys.gameBet.remark,
      };

      this.$store.dispatch("userModule/saveBestBet", obj);
    },

    sendUserPropsBet() {
      let obj = {
        sportId: this.sportId,
        id: this.toggle_exclusive === 0 ? "6107f818963dc87f216fa505" : "60fedc56109bcffeb7010994",
        gold: this.toggle_exclusive === 0 ? this.chazumle.propsBet.gold : this.doughboys.propsBet.gold,
        silver: this.toggle_exclusive === 0 ? this.chazumle.propsBet.silver : this.doughboys.propsBet.silver,
        bronze: this.toggle_exclusive === 0 ? this.chazumle.propsBet.bronze : this.doughboys.propsBet.bronze,
        remark: this.toggle_exclusive === 0 ? this.chazumle.propsBet.remark : this.doughboys.propsBet.remark,
      };

      this.$store.dispatch("userModule/saveBestBetProps", obj);
    },

  },
};
</script>

<style>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
</style>
